import React, { useState, useEffect } from "react";
import "../styles/flyer.css";
import cover from "../assets/cover.jpg";
import { supabase } from '../services/supabase';

export default function Flyers() {
  const [data, setData] = useState({
    poles: [],
    flyers: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchFlyersData();
  }, []);

  const fetchFlyersData = async () => {
    try {
      const { data: flyersData, error } = await supabase
        .from('flyers')
        .select('*')
        .single();

      if (error) {
        console.error('Supabase error:', error);
        setError('Failed to load flyers content');
        return;
      }

      if (flyersData) {
        setData({
          poles: flyersData.poles || [],
          flyers: flyersData.flyers || []
        });
      }
    } catch (error) {
      console.error('Error fetching flyers data:', error);
      setError('Failed to load flyers content');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flyers-section loading">Loading flyers...</div>;
  }

  if (error) {
    return <div className="flyers-section error">Error: {error}</div>;
  }

  return (
    <section id="flyers" className="flyers-section">
      <div className="container">
        {/* DOMAINES D'EXPERTISE */}
        {data.poles.length > 0 && (
          <>
            <h3 className="section-title">Domaines d'Expertise</h3>

            <div className="poles-grid">
              {data.poles.map((pole) => (
                <div key={pole.id} className="pole-card">
                  <h4 className="pole-title">{pole.title}</h4>
                  <ul className="pole-bullets">
                    {pole.bullets?.map((b, i) => (
                      <li key={i} className="bullet-item">
                        <span className="bullet-icon">✓</span>
                        {b}
                      </li>
                    ))}
                  </ul>

                  <div className="livrables">
                    <p className="livrables-text">
                      <strong>Livrables :</strong> {pole.livrablesText}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {/* Flyers Section */}
        {data.flyers.length > 0 && (
          <>
            <h3 className="section-title">Flyers & Brochures</h3>
            <p className="subtitle">Téléchargez nos documents pour plus d'informations.</p>

            <div className="flyer-grid">
              {data.flyers
                .filter(f => f.href && f.thumb) // Only show flyers with both PDF and image
                .map((f) => (
                  <div key={f.id} className="flyer-card">
                    <a href={f.href} target="_blank" rel="noreferrer" className="flyer-link">
                      <div className="book" aria-label={f.title}>
                        <div className="book-cover">
                          <img src={f.thumb} alt={f.title} />
                        </div>
                      </div>
                      <p className="flyer-title">{f.title}</p>
                    </a>
                  </div>
                ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
}
